import { useId } from 'react';
import styles from './InstagramLogo.module.scss';
import classNames from 'classnames/bind';

let cx = classNames.bind(styles);

export function InstagramLogo({ className }) {
  const id = useId();
	const classNameArray = className?.split(' ') || [];

	return (
		<svg className={cx([...classNameArray])} viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-describedby={`instagram-title-${id}`}>
			<title id={`instagram-title-${id}`}>Instagram</title>
			<path d="M7.179.188h9a6.219 6.219 0 0 1 6.214 6.214v9a6.214 6.214 0 0 1-6.214 6.214h-9a6.219 6.219 0 0 1-6.215-6.214v-9A6.214 6.214 0 0 1 7.18.188ZM6.964 2.33a3.857 3.857 0 0 0-3.857 3.857v9.428a3.855 3.855 0 0 0 3.857 3.858h9.429a3.857 3.857 0 0 0 3.857-3.858V6.188a3.855 3.855 0 0 0-3.857-3.857H6.964Zm10.34 1.607a1.34 1.34 0 1 1 0 2.678 1.34 1.34 0 0 1 0-2.678Zm-5.625 1.607a5.357 5.357 0 1 1 0 10.714 5.357 5.357 0 0 1 0-10.714Zm0 2.143a3.214 3.214 0 1 0 0 6.428 3.214 3.214 0 0 0 0-6.428Z" fill="#202020" />
		</svg>
	);
}
